import ReactDOM from 'react-dom';

import Styles from './ConfirmDeleteModal.module.scss';

import { useClickOutside } from '@/app/hooks/useClickOutside';
import { Button } from '@/components/Elements/Button';
import { CloseIcon } from '@/components/Elements/Icons';

interface Props {
	title: string;
	header?: string;
	isLoading?: boolean;
	children?: React.ReactNode;
	onCloseRequest?: () => void;
	onConfirm?: () => void;
}

export const ConfirmDeleteModal = ({
	title,
	children,
	isLoading,
	onCloseRequest,
	onConfirm,
	header = 'JUST CHECKING...',
}: Props) => {
	const { ref } = useClickOutside<HTMLDivElement>(onCloseRequest);

	return ReactDOM.createPortal(
		<div className={Styles.container} ref={ref}>
			<button className={Styles.closeButton} type="button" onClick={onCloseRequest}>
				<CloseIcon />
			</button>
			<div className={Styles.header}>
				<h3>{header}</h3>
				<span>{title}</span>
			</div>
			<div className={Styles.body}>{children}</div>
			<div className={Styles.footer}>
				<Button
					variant="secondary"
					type="button"
					className={Styles.cancel}
					disabled={isLoading}
					onClick={onCloseRequest}
				>
					Cancel
				</Button>
				<Button
					type={'button'}
					className={Styles.delete}
					disabled={isLoading}
					onClick={onConfirm}
				>
					Delete
				</Button>
			</div>
		</div>,
		document.body
	);
};
